import { IPendingSection1Repository } from '../ports/outbound/IPendingSection1Repository';
import { SortOrder } from "@/shared/application/domain/enums/SortOrder";
import { I9ListingFilters } from '@/shared/application/domain/entities/I9ListingFilters';
import { PendingSection1Result } from '../domain/entities/PendingSection1Result';

export class FetchPendingSection1ItemsUseCase {
  constructor(private readonly pendingSection1Repository: IPendingSection1Repository) { }

  async fetchPendingSection1Records(
    page: number,
    pageSize: number,
    columnName?: string,
    sortOrder?: SortOrder,
    filters?: I9ListingFilters
  ): Promise<PendingSection1Result> {
    return this.pendingSection1Repository.fetchPendingSection1Records(
      page,
      pageSize,
      columnName,
      sortOrder,
      filters
    );
  }

  /**
   * Send a pending Section 1 reminder email.
   * @param i9FormId - The I9Form ID to send reminder for
   * @param email - The recipient email address
   */
  async sendEmailReminder(
    i9FormId: string,
    email: string
  ): Promise<{ success: boolean; onCooldown: boolean }> {
    return this.pendingSection1Repository.sendEmailReminder(i9FormId, email);
  }

  /**
   * Re-send the Section 1 AMENDMENT email (fresh capability-token link) for an amendment row.
   * @param i9FormId - The I9Form ID
   * @param email - The recipient email address
   */
  async resendAmendment(
    i9FormId: string,
    email: string
  ): Promise<{ success: boolean; onCooldown: boolean }> {
    return this.pendingSection1Repository.resendAmendment(i9FormId, email);
  }
}
